
export default class UserPolicy
{
    static accessAllCustomersOrders(user)
    {
        return user.role_name === 'writer';
    }

    static accessPrivateInformation(user)
    {
        return user.role === 3 && user.role_name === 'admin';
    }

    static isAssignedUser(user, userInfo)
    {
        return user.id == userInfo.id;
    }

    static show(user, order)
    {
        return true;
    }

    static extendDeadline(user, order)
    {
        return user.id === order.user_id && order.status !== 7 && order.status !== 8;
    }

    static seeDetails(user, order)
    {
        return user.id !== order.user_id;
    }
}